import { render, staticRenderFns } from "./gradeStudy.vue?vue&type=template&id=0fd8c9cc&scoped=true&"
import script from "./gradeStudy.vue?vue&type=script&lang=js&"
export * from "./gradeStudy.vue?vue&type=script&lang=js&"
import style0 from "./gradeStudy.vue?vue&type=style&index=0&id=0fd8c9cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8c9cc",
  null
  
)

export default component.exports